import React, {useRef} from "react";
import { Route, Routes } from "react-router-dom";

import PdLogo from "../../assets/media/logo/pd_logo_(orange).png";
import AuthPageImg from "../../assets/media/background/auth-page-bg-top.png";
import AuthPageBgDispatcher from "../../assets/media/background/auth-page-bg-dispatcher.png";
import AuthPageBgBottomRight from "../../assets/media/background/auth-page-bg-bottom-right.png";

import Login from "./components/Login";
import Registration from "./components/Registration";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";
import AccountVerification from "./components/AccountVerification";
import NotFoundPage from "../404";
import { Link } from "react-router-dom";

const Auth = () => {
  const authContainer = useRef();

  return (
    <section className="auth-body">
      <div className="auth-container" ref={authContainer}>
        <div className="d-flex align-items-center justify-content-end">
          <Link to="/" className="auth-usefull-links">
              Home
          </Link>
        </div>
        <div className="logo logo-registration">
          <a href="/">
            <img src={PdLogo} alt="" />
          </a>
        </div>
        <Routes>
          <Route path="/sign-in" element={<Login authContainer={authContainer} />} />
          <Route path="/sign-up" element={<Registration />} />
          <Route
            path="/account-verification"
            element={<AccountVerification />}
          />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword authContainer={authContainer}/>} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>



      <img className="auth-bg _1" src={AuthPageImg} alt="" />
      <img className="auth-bg _2" src={AuthPageBgDispatcher} alt="" />
      <img className="auth-bg _3" src={AuthPageBgBottomRight} alt="" />
    </section>
  );
};

export default Auth;
